import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"10px","color":"indianred","line-height":"25px","font-weight":"bold"} }, [
  /*#__PURE__*/_createTextVNode(" 提示： "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("“推广页面”：包含推广展示页面 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("“下载地址”：APP直接下载地址 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("必须在浏览器环境下使用，如在应用中推广，请跳转至浏览器或在APP内置浏览器中打开。 ")
], -1)

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'  
import { getStatistics } from '../../api'



export default /*#__PURE__*/_defineComponent({
  __name: 'databsplay',
  setup(__props) {

const  roleStr=ref("");

const domainNameArr = ref([]);
const statistics = reactive({
    visitsToday: 0,
    totalVisits: 0,
    todayIp: 0,
    totalIp: 0,
    dowdsToday: 0,
    totalDowds: 0,
    closedTotalDowds: 0,
    inviteToday: 0,
    totalInvite: 0,
    closedTotalInvite: 0,
    registerToday: 0,
    totalRegister: 0,
    closedTotalRegister: 0,
    agentsNum: 0,
    dailyActivity: 0,
    totalTecharge: 0,
    dailyIncome: 0,
    balance: 0,
    uncashAmount: 0,
    allCard: 0,
    activated: 0,
    inactivated: 0,
    totalRevenue: 0,
    rechargeToday: 0,
    userCount:0,
    
    

   
})

getStatistics().then((res: any) => {
    if (res != "" && res.code == 0) {
        statistics.visitsToday = res.data.visitsToday;
        statistics.totalVisits = res.data.totalVisits;
        statistics.todayIp = res.data.todayIp;
        statistics.totalIp = res.data.totalIp;
        statistics.dowdsToday = res.data.dowdsToday;
        statistics.totalDowds = res.data.totalDowds;
        statistics.closedTotalDowds = res.data.closedTotalDowds;
        domainNameArr.value = res.data.domainNameList;

        statistics.inviteToday = res.data.inviteToday;
        statistics.totalInvite = res.data.totalInvite;
        statistics.closedTotalInvite = res.data.closedTotalInvite;
        statistics.registerToday = res.data.registerToday;
        statistics.totalRegister = res.data.totalRegister; 
        statistics.closedTotalRegister = res.data.closedTotalRegister; 
        statistics.agentsNum = res.data.agentsNum; 
        statistics.dailyActivity = res.data.dailyActivity; 
        statistics.totalTecharge = res.data.totalTecharge; 
        statistics.rechargeToday = res.data.rechargeToday; 
        statistics.totalRevenue = res.data.totalRevenue; 
        statistics.dailyIncome = res.data.dailyIncome; 
        statistics.balance = res.data.balance; 
        statistics.uncashAmount = res.data.uncashAmount; 
        statistics.allCard = res.data.allCard; 
        statistics.activated = res.data.activated; 
        statistics.inactivated = res.data.inactivated; 
        statistics.userCount = res.data.userCount; 

        

        roleStr.value=res.msg;

    }

})

const copyText = (str: any) => {
    const textarea = document.createElement('textarea');
    textarea.value = str;
    // 将 textarea 添加到 body 中
    document.body.appendChild(textarea);
    // 选中 textarea 中的内容
    textarea.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除 textarea 元素
    document.body.removeChild(textarea);
    
    layer.msg('复制成功')

}


return (_ctx: any,_cache: any) => {
  const _component_lay_card = _resolveComponent("lay-card")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_button = _resolveComponent("lay-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_card, { title: "今预览" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(statistics.visitsToday), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_card, { title: "总预览" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(statistics.totalVisits), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_card, { title: "今ip" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(statistics.todayIp), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_card, { title: "总ip" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(statistics.totalIp), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (roleStr.value=='measure'||roleStr.value=='generalAgent'||roleStr.value=='agent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 0,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "今下载" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.dowdsToday), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='measure'||roleStr.value=='generalAgent'||roleStr.value=='agent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 1,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "总下载" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.totalDowds+statistics.closedTotalDowds), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='measure'||roleStr.value=='generalAgent'||roleStr.value=='agent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 2,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "今安装" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.inviteToday), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='measure'||roleStr.value=='generalAgent'||roleStr.value=='agent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 3,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "总安装" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.totalInvite+statistics.closedTotalInvite), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='measure'||roleStr.value=='generalAgent'||roleStr.value=='agent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 4,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "今注册" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.registerToday), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='measure'||roleStr.value=='generalAgent'||roleStr.value=='agent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 5,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "总注册" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.totalRegister+statistics.closedTotalRegister), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='dividedAdmin'||roleStr.value=='dividedGeneralAgent'||roleStr.value=='dividedAgent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 6,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "总邀新" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.userCount), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='dividedAdmin'||roleStr.value=='dividedGeneralAgent'||roleStr.value=='dividedAgent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 7,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "今充值" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.rechargeToday), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='dividedAdmin'||roleStr.value=='dividedGeneralAgent'||roleStr.value=='dividedAgent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 8,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "总充值" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.totalTecharge), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='dividedAdmin'||roleStr.value=='dividedGeneralAgent'||roleStr.value=='dividedAgent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 9,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "今收益" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.dailyIncome), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='dividedAdmin'||roleStr.value=='dividedGeneralAgent'||roleStr.value=='dividedAgent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 10,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "总收益" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.totalRevenue), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='dividedGeneralAgent'||roleStr.value=='dividedAgent')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 11,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "可提现余额" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.balance), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='dividedAdmin'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 12,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "未提现余额" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.uncashAmount), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 13,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "全部卡密" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.allCard), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='cardamomAdmin'||roleStr.value=='cardamomAgent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 14,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "未激活" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.inactivated), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='cardamomAdmin'||roleStr.value=='cardamomAgent'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 15,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "已激活" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.activated), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='measure'||roleStr.value=='generalAgent'||roleStr.value=='superAdmin'||roleStr.value=='dividedAdmin'||roleStr.value=='dividedGeneralAgent')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 16,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "代理" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.agentsNum), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (roleStr.value=='measure'||roleStr.value=='superAdmin')
          ? (_openBlock(), _createBlock(_component_lay_col, {
              key: 17,
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_card, { title: "日活" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statistics.dailyActivity), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (domainNameArr.value.length != 0)
      ? (_openBlock(), _createBlock(_component_lay_card, {
          key: 0,
          title: "推广地址",
          style: {"margin-top":"10px","text-align":"left"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domainNameArr.value, (domain) => {
              return (_openBlock(), _createElementBlock("div", {
                key: domain.domainName
              }, [
                (domain.type==1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, " 防墙推广域名： "))
                  : (domain.type==2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, " 普通推广域名： "))
                    : (domain.type==3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 防墙下载域名： "))
                      : (domain.type==4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " 普通下载域名： "))
                        : _createCommentVNode("", true),
                _createElementVNode("a", null, _toDisplayString(domain.domainName), 1),
                _createVNode(_component_lay_button, {
                  type: "primary",
                  onClick: ($event: any) => (copyText(domain.domainName)),
                  size: "xs",
                  style: {"margin-left":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("点击复制")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            _hoisted_5
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})